import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook, faInstagram, faXTwitter, faYoutube, faLinkedin, } from "@fortawesome/free-brands-svg-icons";
import "./footer.css";

/**
 * Footer Component
 * componente que muestra el footer de la pagina
 */
const Footer = () => {
    return (
        <footer style={{backgroundColor: "#F5DFB3", margin: 0, display: "flex", justifyContent: "space-evenly"}}>
            <div>
                <p>Contactos:</p>
                <p>Correo: contacto@pawzone.cl </p>
                <p>Teléfono: +56 9 4483 2972</p>
            </div>
            <div>
                <p>Redes Sociales:</p>
                <FontAwesomeIcon
                    icon={faFacebook} 
                    size="2x" 
                    color="#382A15"
                />
                <a href="https://www.instagram.com/pawzone.cl/" target="_blank" rel="noopener noreferrer">
                    <FontAwesomeIcon 
                        icon={faInstagram} 
                        size="2x"
                        color="#382A15" 
                    />
                </a>
                <FontAwesomeIcon 
                    icon={faXTwitter} 
                    size="2x"
                    color="#382A15" 
                />
                <FontAwesomeIcon 
                    icon={faYoutube} 
                    size="2x"
                    color="#382A15" 
                />
                <FontAwesomeIcon 
                    icon={faLinkedin} 
                    size="2x"
                    color="#382A15" 
                />
            </div>
        </footer>
    );
};

export default Footer;
